import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import ProtectedRoute from "components/ProtectedRoute";
import CompanyProfileManagement from './pages/company-profile-management';
import AdminDashboard from './pages/admin-dashboard';
import VisualizerFlow from './pages/visualizer-flow';
import AdminLogin from './pages/admin-login';
import GalleryProjects from './pages/gallery-projects';
import GlobalDefaultsManagement from './pages/global-defaults-management';
import ClientDashboardHome from './pages/client-dashboard-home';
import ColorsManagement from './pages/colors-management';
import CompanyCreateEdit from './pages/company-create-edit';
import FloorTypesPricing from './pages/floor-types-pricing';
import EmbedLinksManagement from './pages/embed-links-management';
import RoomsManagement from './pages/rooms-management';
import CompanyLogin from './pages/company-login';
import AnalyticsDashboard from './pages/analytics-dashboard';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Public Routes */}
        <Route path="/" element={<AdminLogin />} />
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/company-login" element={<CompanyLogin />} />
        <Route path="/company-login/:companyIdentifier" element={<CompanyLogin />} />
        
        {/* Protected Admin Routes */}
        <Route path="/admin-dashboard" element={
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        } />
        <Route path="/company-profile-management" element={
          <ProtectedRoute>
            <CompanyProfileManagement />
          </ProtectedRoute>
        } />
        <Route path="/global-defaults-management" element={
          <ProtectedRoute>
            <GlobalDefaultsManagement />
          </ProtectedRoute>
        } />
        <Route path="/colors-management" element={
          <ProtectedRoute>
            <ColorsManagement />
          </ProtectedRoute>
        } />
        <Route path="/company-create-edit" element={
          <ProtectedRoute>
            <CompanyCreateEdit />
          </ProtectedRoute>
        } />
        <Route path="/floor-types-pricing" element={
          <ProtectedRoute>
            <FloorTypesPricing />
          </ProtectedRoute>
        } />
        <Route path="/embed-links-management" element={
          <ProtectedRoute>
            <EmbedLinksManagement />
          </ProtectedRoute>
        } />
        <Route path="/rooms-management" element={
          <ProtectedRoute>
            <RoomsManagement />
          </ProtectedRoute>
        } />
        <Route path="/gallery-projects" element={
          <ProtectedRoute>
            <GalleryProjects />
          </ProtectedRoute>
        } />

        {/* Public Company Routes */}
        <Route path="/visualizer/:companyIdentifier" element={<VisualizerFlow />} />
        <Route path="/client/:companyIdentifier" element={<ClientDashboardHome />} />
        <Route path="/client/:companyIdentifier/profile" element={<CompanyProfileManagement />} />
        <Route path="/client/:companyIdentifier/floor-types" element={<FloorTypesPricing />} />
        <Route path="/client/:companyIdentifier/colors" element={<ColorsManagement />} />
        <Route path="/client/:companyIdentifier/rooms" element={<RoomsManagement />} />
        <Route path="/client/:companyIdentifier/gallery" element={<GalleryProjects />} />
        <Route path="/client/:companyIdentifier/embed" element={<EmbedLinksManagement />} />
        <Route path="/client/:companyIdentifier/analytics" element={<AnalyticsDashboard />} />
        <Route path="/analytics-dashboard" element={<AnalyticsDashboard />} />
        <Route path="/embed/:companyIdentifier" element={<VisualizerFlow />} />
        <Route path="/visualizer-flow" element={<VisualizerFlow />} />
        <Route path="/company-dashboard-home" element={<ClientDashboardHome />} />
        <Route path="/company/:companyIdentifier" element={<ClientDashboardHome />} />
        
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;